import { render, staticRenderFns } from "./LightboxBase.vue?vue&type=template&id=f5929804&scoped=true&"
import script from "./LightboxBase.vue?vue&type=script&lang=js&"
export * from "./LightboxBase.vue?vue&type=script&lang=js&"
import style0 from "./LightboxBase.vue?vue&type=style&index=0&id=f5929804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5929804",
  null
  
)

export default component.exports